module.exports = __webpack_public_path__ + "static/media/ecmascript6.adf1f325.png";